import { useQuery } from '@tanstack/react-query';
import iotApi from 'lib/api/iotApi.client';
import {
  GetRecentEsimOrdersParams,
  GetRecentPSimOrdersParams,
} from 'lib/api/requests/dashboard/dashboard.requests.types';
import { DashboardQueryKey } from './dashboard.hooks.keys';

export function useGetOrdersReport() {
  return useQuery({
    queryKey: [DashboardQueryKey.GET_ORDERS_REPORT],
    queryFn: async () => {
      const res = await iotApi.dashboard.getReport({ type: 'orders' });

      return res.data;
    },
  });
}

export function useGetRecentEsimOrders(params: GetRecentEsimOrdersParams) {
  return useQuery({
    queryKey: [DashboardQueryKey.GET_RECENT_ESIM_ORDERS, params],
    queryFn: async () => {
      const res = await iotApi.dashboard.getRecentEsimOrders(params);

      return res.data;
    },
  });
}

export function useGetRecentPSimOrders(params: GetRecentPSimOrdersParams) {
  return useQuery({
    queryKey: [DashboardQueryKey.GET_RECENT_PSIM_ORDERS, params],
    queryFn: async () => {
      const res = await iotApi.dashboard.getRecentPSimOrders(params);

      return res.data;
    },
  });
}
